import en from "./en.json";
import it from "./it.json";

const tWallet = { en, it };

export default tWallet;
